var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pillBase flex justify-around items-center px-1 sm:px-4 rounded w-fit min-w-[2.75rem] h-full"},[_c('img',{staticClass:"go-back-icon",attrs:{"src":require('@/assets/images/chevron-left.svg')}}),_c('span',{staticClass:"hidden sm:block"},[_vm._v("Back")])])
}
var staticRenderFns = []

export { render, staticRenderFns }